import { Typography } from "@mui/material"
import React from "react"
import { SerifFont } from "src/theme"

export function Logo() {
  return (
    <Typography
      variant="h5"
      fontFamily={SerifFont}
      fontWeight={600}
      letterSpacing="0.03125rem"
      padding={0}
    >
      Privatefolio
    </Typography>
  )
}
